import {GraphRangeContext, GraphRangeProvider} from '#/components/graphs/graph-range-selector';
import LandMarketDataGraph from '#/components/graphs/land-market-data-graph';
import {useLands} from '#/hooks/query/use-lands';
import {FunctionComponent} from 'react';
import {useParams} from 'react-router';

export const MarketDataTickerEmbed: FunctionComponent = () => {
  const {tokenSymbol} = useParams();

  const {data: lands} = useLands();
  const land = lands?.find(land => !!tokenSymbol && land.tokenSymbol === tokenSymbol);

  if (!land) {
    return null;
  }

  return (
    <div className='space-y-4'>
      <div className='block text-black dark:text-white font-bold text-xl'>{land.name}</div>
      <GraphRangeProvider>
        <GraphRangeContext.Consumer>
          {({graphRange}) => <LandMarketDataGraph className='block' land={land} graphRange={graphRange} />}
        </GraphRangeContext.Consumer>
      </GraphRangeProvider>
    </div>
  );
};
